<template>
    <ls-panel class="ls-border-all" :hide-divider="true">
        <div class="grid__col-12 ls-margin--vertical">
            <div class="ls-align--center">
                <span class="fa-stack fa-2x ls-color--green">
                    <i class="fa fa-stack-2x fa-circle"></i>
                    <i class="fa fa-stack-1x fa-spin fa-leaf fa-inverse"></i>
                </span>
            </div>
            <p class="ls-align--center ls-margin--bottom" data-font-size="-1">
                Calculating Price&hellip;
            </p>
        </div>
    </ls-panel>
</template>

<script>
import lsPanel from '@/components/original-mydot/panel/Panel.vue';

export default {
    components: {
        lsPanel,
    },
};
</script>

<style lang="scss"></style>
